import * as React from 'react'
import { helperPlaceholderSVG } from '../../helpers.mod'

export const OtherKeyProjectsBlock = () => {
  return (
    <section className="block block--others block-bg--grey">
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Other key projects</h2>
        </header>
        <div className='block__content'>
          <ul className='block__list grid'>
            {OtherKeyProjectsItem('Morbi leo risus, porta ac consectetur ac, vestibulum at eros.', '/')}
            {OtherKeyProjectsItem('Cras mattis consectetur purus sit amet fermentum.', '/')}
            {OtherKeyProjectsItem('Porta ac consectetur ac, vestibulum at eros.', '/')}
          </ul>
        </div>
      </div>
    </section>
  )
}

export const OtherKeyProjectsItem = (title: string, linkUrl: string ) => {
  return (
    <li className='grid__item'>
      <article className='grid__article'>
        <a className="grid__link" href={linkUrl}>
          <div className='grid__content'>
            <header className="grid__header">
              <h3 className="grid__title title--s">{title}</h3>
              <a className="grid__link"></a>
            </header>
          </div>
          <div className='grid__visual fit-object'>
            <img loading="lazy" className='grid__image' width={480} height={300} src={helperPlaceholderSVG({ shape: { width: 480, height: 300, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="Placeholder" />
          </div>
        </a> 
      </article>
    </li>
  )
}
